import { useEffect } from 'react';
import { ScanModule } from '@/mobile/modulos/scan/ScanModule';

interface ScanShellProps {
  onClose: () => void;
}

/**
 * Overlay fullscreen para o fluxo de escaneamento.
 * z-60 cobre todo o MobileFrame — inclusive tabbar.
 * Renderiza ScanModule que gerencia view|processing|review|error.
 */
export function ScanShell({ onClose }: ScanShellProps) {
  // Fechar com Escape (teclado físico / desktop)
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Escanear documento"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 60,
        background: '#0b0d0c',
        overflow: 'hidden',
      }}
    >
      <ScanModule onClose={onClose} />
    </div>
  );
}
